/**
 * @generated SignedSource<<42468d194e6312e677796e9abb5f25a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeliveryStatus = "BOUNCED" | "DELIVERED" | "FAILED" | "QUEUED" | "SENT" | "%future added value";
export type MarketingEmailDeliveryViewQuery$variables = {
  marketingEmailId: string;
};
export type MarketingEmailDeliveryViewQuery$data = {
  readonly marketingEmailDeliveries: ReadonlyArray<{
    readonly bounceType: string | null | undefined;
    readonly bouncedAt: any | null | undefined;
    readonly contact: {
      readonly familyName?: string;
      readonly givenName?: string;
      readonly id: string;
      readonly teamName?: string;
    } | null | undefined;
    readonly deliveredAt: any | null | undefined;
    readonly id: string;
    readonly recipientEmail: string;
    readonly sentAt: any | null | undefined;
    readonly status: DeliveryStatus;
  }>;
  readonly marketingEmailDeliveryStats: {
    readonly bounced: number;
    readonly delivered: number;
    readonly failed: number;
    readonly queued: number;
    readonly sent: number;
    readonly total: number;
  };
};
export type MarketingEmailDeliveryViewQuery = {
  response: MarketingEmailDeliveryViewQuery$data;
  variables: MarketingEmailDeliveryViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "marketingEmailId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "marketingEmailId",
    "variableName": "marketingEmailId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recipientEmail",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deliveredAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bouncedAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bounceType",
  "storageKey": null
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "givenName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "familyName",
      "storageKey": null
    }
  ],
  "type": "PersonContact",
  "abstractKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamName",
      "storageKey": null
    }
  ],
  "type": "TeamContact",
  "abstractKey": null
},
v11 = {
  "alias": null,
  "args": (v1/*: any*/),
  "concreteType": "MarketingEmailDeliveryStats",
  "kind": "LinkedField",
  "name": "marketingEmailDeliveryStats",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "queued",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "delivered",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bounced",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "failed",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MarketingEmailDeliveryViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EmailDelivery",
        "kind": "LinkedField",
        "name": "marketingEmailDeliveries",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v11/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MarketingEmailDeliveryViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EmailDelivery",
        "kind": "LinkedField",
        "name": "marketingEmailDeliveries",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v11/*: any*/)
    ]
  },
  "params": {
    "cacheID": "d87506b35e2db33eff80fc4977e14282",
    "id": null,
    "metadata": {},
    "name": "MarketingEmailDeliveryViewQuery",
    "operationKind": "query",
    "text": "query MarketingEmailDeliveryViewQuery(\n  $marketingEmailId: ID!\n) {\n  marketingEmailDeliveries(marketingEmailId: $marketingEmailId) {\n    id\n    recipientEmail\n    status\n    sentAt\n    deliveredAt\n    bouncedAt\n    bounceType\n    contact {\n      __typename\n      id\n      ... on PersonContact {\n        givenName\n        familyName\n      }\n      ... on TeamContact {\n        teamName\n      }\n    }\n  }\n  marketingEmailDeliveryStats(marketingEmailId: $marketingEmailId) {\n    total\n    queued\n    sent\n    delivered\n    bounced\n    failed\n  }\n}\n"
  }
};
})();

(node as any).hash = "f8ca2238704bb3dddbe26588aef651c3";

export default node;
